import { createFileRoute } from '@tanstack/react-router';
import { SignedOutPage, SignedOutSearchSchema } from '@/features/session';

/** Public: shown after sign-out and when a sign-in or step-up did not complete. */
export const Route = createFileRoute('/signed-out')({
  validateSearch: (search) => SignedOutSearchSchema.parse(search),
  component: SignedOutRoute,
});

function SignedOutRoute() {
  const { reason } = Route.useSearch();
  return <SignedOutPage reason={reason} />;
}
